class ArticleProducts extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.contentProdsEl = document.querySelector(".article-products")),
      !this.contentProdsEl)
    )
      return;
    window.initLazyScript(this, this.init.bind(this));
  }
  init() {
    (this.prodEls = this.contentProdsEl.querySelectorAll(
      "[data-lazy-product-handle]"
    )),
      (this.ratioSetting = theme.settings.prodCardImageRatio),
      (this.ratioValue = this.ratioSetting),
      "shortest" === this.ratioSetting
        ? (this.ratioValue = 0)
        : "tallest" === this.ratioSetting && (this.ratioValue = 99),
      Shopify.designMode &&
        document.addEventListener(
          "shopify:section:load",
          this.loadFeaturedProducts.bind(this)
        ),
      this.loadFeaturedProducts();
  }
  async loadFeaturedProducts() {
    this.contentProdsEl.classList.add("is-loading"),
      await Promise.all(
        Array.from(this.prodEls).map(async (t) => {
          await this.getProduct(t);
        })
      ),
      this.contentProdsEl.querySelectorAll(".prod-image__main").forEach((t) => {
        t.style.paddingTop = `${(1 / this.ratioValue) * 100}%`;
      }),
      this.contentProdsEl.classList.remove("is-loading");
  }
  async getProduct(t) {
    try {
      let e = await fetch(
        `/products/${t.dataset.lazyProductHandle}/?section_id=product-card`
      );
      if (!e.ok) throw Error(e.status);
      let i = document.createElement("template");
      if (
        ((i.innerHTML = await e.text()),
        "shortest" === this.ratioSetting || "tallest" === this.ratioSetting)
      ) {
        let s = i.content.querySelector(".card__main-image");
        if (s) {
          let { paddingTop: a } = s.style,
            r = 1 / (Number(a.slice(0, -1)) / 100);
          "shortest" === this.ratioSetting
            ? r > this.ratioValue && (this.ratioValue = r)
            : r < this.ratioValue && (this.ratioValue = r);
        }
      }
      t.replaceWith(i.content.querySelector(".card"));
    } catch (o) {
      t.remove();
    }
  }
}
customElements.define("article-products", ArticleProducts);
